// Human-readable labels for order fields — used by the low-confidence flag
// surfaces (All Orders row badge, upload/confirmation callout). One source of
// truth so the two lists always read the same.
export const FIELD_LABELS = {
  recipient_name: 'Name', recipient_street_address: 'Address',
  recipient_street_address_2: 'Apt/Suite', recipient_city: 'City',
  recipient_state: 'State', recipient_zip_code: 'Zip', recipient_phone: 'Phone',
  order_number: 'Order #', network_source: 'Source', delivery_date: 'Delivery date',
  total_price: 'Total price', delivery_time_requirement: 'Delivery time',
  product_code: 'Product code', product_name: 'Product name',
  subsource_extracted: 'Sending florist',
  card_message: 'Card message', product_description: 'Product description',
  special_instructions: 'Special instructions', size: 'Size',
};

export const formatFieldLabel = (f) => FIELD_LABELS[f] || f.replace(/_/g, ' ');
